import React from 'react';
import PageBanner from '../../../layout/PageBanner';
import { Link } from 'react-router-dom';

const PublicacionesDetalle = (props) => (
	<div>
		<PageBanner title="Publicaciones" img="banner-publicaciones.jpg">
			<Link to="/">Home</Link>
			<Link to="/Publicaciones">Publicaciones</Link>
		</PageBanner>

		<section className="about-ds">
			<div className="container">
				<div className="row">
					<div className="col-md-7 col-sm-6 about-ds-content">
						<div className="section-header03">
							<h2 className="flacso-verde">{props.location.state.props.mainState.fields.Titulo}</h2>
						</div>
						<p dangerouslySetInnerHTML={{ __html: props.location.state.props.mainState.fields.Descripcion }}>
						</p>
						<a href={props.location.state.props.mainState.fields.PDF[0].url} target="_blank" className="rm-btn el-btn-regular flacso-verde">Ver PDF</a>
						<br /><br />
					</div>
					<div className="col-md-5 col-sm-6 about-ds-image">
						<img src={props.location.state.props.mainState.fields.ImagenPrincipal ? props.location.state.props.mainState.fields.ImagenPrincipal[0].url : 'https://via.placeholder.com/300x300.png?text=Flacso'} 
								 alt={props.location.state.props.mainState.fields.Titulo} 
								 className="img-responsive" />
					</div>
				</div>
			</div>
		</section>

	</div>
);

export default PublicacionesDetalle;
